/* CBC — panier tiroir (v3, 2026-09-26).

   Rendu depuis `window.CBC_CART` : ouvrir ne coûte aucune requête.

   Quantités : les clics modifient d'abord l'affichage (optimiste), puis TOUTES les
   modifications en attente partent en UNE seule requête `/cart/update.js` après 260 ms
   d'inactivité. Quand une réponse revient, les modifications encore en attente sont
   réappliquées par-dessus l'état serveur avant le rendu : un article supprimé ne
   réapparaît donc jamais (c'était le bug « il faut cliquer plusieurs fois »).
   Si le serveur refuse une clé de ligne devenue obsolète, on relit le panier, on
   retrouve la ligne par variante et on relance une fois.

   Cadeaux : une ligne est un cadeau si sa variante est listée, si elle porte la
   propriété `_offert`, ou si son prix d'origine est 0. Les cadeaux ne comptent jamais
   comme des journaux.

   Livraison offerte : la vraie règle Shopify est au poids (≥ 700 g par défaut), donc la
   barre lit `cart.total_weight` et ne peut plus mentir.

   Devise : tout est formaté dans la devise réelle du panier (`cart.currency`). */
(function () {
  "use strict";

  var CFG = window.CBC_CART_CONFIG || {};
  var GIFT_IDS = CFG.giftIds || [];
  var BOOK_PIDS = CFG.bookProductIds || [];       // produits comptés comme « journaux »
  var GAME_PIDS = CFG.gameProductIds || BOOK_PIDS; // journaux qui donnent droit au jeu
  var GIFT_MIN = CFG.giftMin || 2;
  var SHIP_GRAMS = CFG.freeShipGrams || 700;
  var BOOK_GRAMS = CFG.bookGrams || 400;
  var UNIT = CFG.unitCents || 0;
  var TIERS = CFG.tiers || {};
  var FAM_PCT = CFG.famillePct || 40;
  var DEBOUNCE = CFG.debounceMs == null ? 260 : CFG.debounceMs;
  var cart = window.CBC_CART || { items: [], item_count: 0 };
  var lastFocus = null, giftBusy = false, internalDepth = 0;
  var pending = {}, pendingVid = {}, flushT = null, inFlight = false;
  var variantCache = {}, moreOpen = {};

  var GIFT_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M20 12v9H4v-9"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 21V7"/>'
    + '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>'
    + '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var PLUS_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  var root = document.querySelector("[data-cbcd]");
  var scrim = document.querySelector("[data-cbcd-scrim]");
  if (!root || !scrim) return;

  var rawFetch = window.fetch.bind(window);
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var itemsEl = $("[data-cbcd-items]");
  var countEl = $("[data-cbcd-count]");
  var shipEl = $("[data-cbcd-ship]");
  var upsellEl = $("[data-cbcd-upsell]");

  /* ---------- helpers ---------- */
  var nfCache = {};
  function money(c) {
    var cur = cart.currency || "EUR";
    if (!(cur in nfCache)) {
      try {
        nfCache[cur] = new Intl.NumberFormat(document.documentElement.lang || "fr", { style: "currency", currency: cur });
      } catch (e) { nfCache[cur] = null; }
    }
    var nf = nfCache[cur];
    return nf ? nf.format(c / 100) : (c / 100).toFixed(2).replace(".", ",") + "\u00a0" + cur;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  function isGift(it) {
    if (GIFT_IDS.indexOf(it.variant_id) !== -1) return true;
    if (it.properties && it.properties._offert) return true;
    return it.original_price === 0;
  }
  function isBook(it) {
    if (isGift(it)) return false;
    return BOOK_PIDS.length ? BOOK_PIDS.indexOf(it.product_id) !== -1 : true;
  }
  function hasGift() { return (cart.items || []).some(function (it) { return GIFT_IDS.indexOf(it.variant_id) !== -1; }); }
  function img(src, w) { return src ? src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, "_" + w + "x$1$2") : ""; }
  function count(pred) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (pred(it)) n += it.quantity; });
    return n;
  }
  function bookCount() { return count(isBook); }
  function gameBookCount() { return count(function (it) { return !isGift(it) && GAME_PIDS.indexOf(it.product_id) !== -1; }); }
  function tierTotal(q) {
    if (q <= 0) return 0;
    if (q >= 4) return Math.round(q * UNIT * (1 - FAM_PCT / 100));
    if (TIERS[q] != null) return TIERS[q];
    return q * UNIT;
  }
  function nextOfferLabel() {
    var next = gameBookCount() + 1, parts = [];
    if (UNIT > 0) {
      var pct = Math.round((1 - tierTotal(next) / (next * UNIT)) * 100);
      if (pct > 0) parts.push("\u2212" + pct + "\u00a0%");
    }
    if (next >= GIFT_MIN && !hasGift() && GIFT_IDS.length) parts.push("le jeu offert");
    return parts.length ? "Ajoutez un livre et obtenez " + parts.join(" + ") : "Ajoutez un autre livre";
  }

  /* ---------- optimistic state ---------- */
  function applyPending(c) {
    var keys = Object.keys(pending);
    if (!keys.length) return c;
    (c.items || []).forEach(function (it) { if (it.key in pending) it.quantity = pending[it.key]; });
    c.items = (c.items || []).filter(function (it) { return it.quantity > 0; });
    c.item_count = (c.items || []).reduce(function (s, it) { return s + it.quantity; }, 0);
    return c;
  }
  function setCart(c) { cart = applyPending(c || { items: [], item_count: 0 }); }

  /* ---------- render ---------- */
  function render() {
    var paid = [], gifts = [];
    (cart.items || []).forEach(function (it) { (isGift(it) ? gifts : paid).push(it); });

    var groups = [], gix = {};
    paid.forEach(function (it) {
      if (gix[it.product_id] == null) { gix[it.product_id] = groups.length; groups.push({ handle: it.handle, vars: [], vix: {} }); }
      var g = groups[gix[it.product_id]];
      if (g.vix[it.variant_id] == null) {
        g.vix[it.variant_id] = g.vars.length;
        g.vars.push({
          vid: it.variant_id,
          name: it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_title,
          image: it.image, qty: 0, final: 0, orig: 0, keys: []
        });
      }
      var v = g.vars[g.vix[it.variant_id]];
      v.qty += it.quantity;
      v.final += it.final_line_price;
      v.orig += it.original_line_price;
      v.keys.push(it.key);
    });

    var html = "";
    if (!paid.length && !gifts.length) html = '<div class="cbcd-empty">Votre panier est vide.</div>';

    groups.forEach(function (g) {
      var n = g.vars.reduce(function (s, v) { return s + v.qty; }, 0);
      html += '<article class="cbcd-prod">';
      if (g.vars.length > 1) html += '<p class="cbcd-sum">' + n + " exemplaires \u00b7 " + g.vars.length + " destinataires</p>";
      g.vars.forEach(function (v) {
        var save = v.orig - v.final, keys = esc(v.keys.join("|"));
        html +=
          '<div class="cbcd-v" data-vid="' + v.vid + '">' +
            (v.image ? '<img src="' + esc(img(v.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
            '<div class="cbcd-mid"><div class="cbcd-name">' + esc(v.name) + "</div>" +
              '<div class="cbcd-qty"><span class="cbcd-step">' +
                '<button type="button" data-act="dec" data-keys="' + keys + '" aria-label="Retirer un">\u2212</button>' +
                "<span>" + v.qty + "</span>" +
                '<button type="button" data-act="inc" data-keys="' + keys + '" aria-label="Ajouter un">+</button></span>' +
                '<button type="button" class="cbcd-trash" data-act="del" data-keys="' + keys + '" aria-label="Supprimer">' +
                  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3"/></svg>' +
                "</button></div></div>" +
            '<div class="cbcd-price">' +
              (save > 0 ? '<span class="cbcd-cut">\u2212' + money(save) + "</span>" : "") +
              "<b>" + money(v.final) + "</b>" + (save > 0 ? "<s>" + money(v.orig) + "</s>" : "") +
            "</div></div>";
      });
      var vars = g.handle ? variantCache[g.handle] : null;
      if (vars && vars.length > 1) {
        var open = !!moreOpen[g.handle];
        var opts = '<option value="" selected disabled>S\u00e9lectionner votre livre</option>' +
          vars.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + "</option>"; }).join("");
        html += '<div class="cbcd-more"' + (open ? " data-open" : "") + ">" +
          '<select class="cbcd-mini cbcd-morevar" data-morevar="' + esc(g.handle) + '" aria-label="Destinataire \u00e0 ajouter"' + (open ? "" : " hidden") + ">" + opts + "</select>" +
          '<button type="button" data-act="more" data-handle="' + esc(g.handle) + '">' + (open ? "" : PLUS_ICON) + " " + esc(open ? "Ajouter" : nextOfferLabel()) + "</button></div>";
      }
      html += "</article>";
    });

    gifts.forEach(function (it) {
      html += '<article class="cbcd-gift" data-vid="' + it.variant_id + '">' +
        (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
        '<div><div class="t">' + (it.quantity > 1 ? it.quantity + " \u00d7 " : "") + esc(it.product_title) + "</div>" +
        '<div class="s">' + GIFT_ICON + " Offert</div></div><b>" + money(0) + "</b></article>";
    });

    itemsEl.innerHTML = html;
    groups.forEach(function (g) { if (g.handle && variantCache[g.handle] === undefined) loadVariants(g.handle); });

    /* Livraison : au poids réel du panier. */
    var grams = cart.total_weight || 0;
    var done = grams >= SHIP_GRAMS;
    var pct = Math.min(100, (grams / SHIP_GRAMS) * 100);
    $("[data-cbcd-fill]").style.width = pct + "%";
    $("[data-cbcd-knob]").style.left = pct + "%";
    if (done) shipEl.setAttribute("data-done", ""); else shipEl.removeAttribute("data-done");
    var left = Math.max(1, Math.ceil((SHIP_GRAMS - grams) / BOOK_GRAMS));
    $("[data-cbcd-shiptxt]").innerHTML = done ? "Livraison offerte"
      : !(cart.items || []).length ? "Livraison offerte d\u00e8s 2 journaux"
      : left === 1 ? "Plus qu'<b>un journal</b> pour la livraison offerte"
      : "Plus que <b>" + left + " journaux</b> pour la livraison offerte";

    var save = (cart.original_total_price || 0) - (cart.total_price || 0);
    var titles = (cart.cart_level_discount_applications || []).map(function (a) { return a.title; }).filter(Boolean);
    var books = bookCount();
    countEl.textContent = cart.item_count || 0;
    $("[data-cbcd-sub]").textContent = money(cart.total_price || 0);
    $("[data-cbcd-subcompare]").textContent = save > 0 ? money(cart.original_total_price) : "";
    $("[data-cbcd-cutrow]").style.display = save > 0 ? "" : "none";
    $("[data-cbcd-cuttag]").textContent = titles.length ? titles[0] : books + (books > 1 ? " Livres" : " Livre");
    $("[data-cbcd-cut]").textContent = "\u2212" + money(save);
    $("[data-cbcd-total]").textContent = money(cart.total_price || 0);
    $("[data-cbcd-go]").disabled = !((cart.items || []).length > 0) || inFlight || Object.keys(pending).length > 0;
    if (upsellEl) upsellEl.hidden = !(cart.item_count > 0);
    syncUpsell();
  }

  function loadVariants(handle) {
    variantCache[handle] = null;
    rawFetch("/products/" + handle + ".js").then(function (r) { return r.json(); })
      .then(function (p) { variantCache[handle] = (p.variants || []).filter(function (v) { return v.available; }); render(); })
      .catch(function () { variantCache[handle] = []; });
  }

  /* ---------- network ---------- */
  function post(url, body) {
    internalDepth++;
    return rawFetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(j && (j.description || j.message) ? j.description || j.message : "HTTP " + r.status);
          err.status = r.status; throw err;
        }
        return j;
      });
    }).then(function (j) { internalDepth--; return j; }, function (e) { internalDepth--; throw e; });
  }
  function getCart() { return rawFetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }

  function lineByKey(key) { return (cart.items || []).filter(function (it) { return it.key === key; })[0] || null; }

  function setQty(key, qty) {
    qty = Math.max(0, qty);
    var line = lineByKey(key);
    if (line) pendingVid[key] = line.variant_id;
    pending[key] = qty;
    setCart(cart);
    render();
    window.clearTimeout(flushT);
    flushT = window.setTimeout(flush, DEBOUNCE);
  }

  /* Une clé refusée : on retrouve la ligne actuelle de la même variante. */
  function remap(batch, fresh) {
    var out = {};
    Object.keys(batch).forEach(function (k) {
      if ((fresh.items || []).some(function (it) { return it.key === k; })) { out[k] = batch[k]; return; }
      var vid = pendingVid[k];
      var match = (fresh.items || []).filter(function (it) { return it.variant_id === vid && !(it.key in out); })[0];
      if (match) out[match.key] = batch[k];
    });
    return out;
  }

  function flush() {
    if (inFlight) { window.clearTimeout(flushT); flushT = window.setTimeout(flush, 80); return; }
    var batch = pending;
    if (!Object.keys(batch).length) return;
    pending = {};
    inFlight = true; root.setAttribute("data-busy", "");
    post("/cart/update.js", { updates: batch })
      .catch(function (e) {
        if (e.status && e.status >= 500) throw e;
        return getCart().then(function (fresh) {
          var retry = remap(batch, fresh);
          return Object.keys(retry).length ? post("/cart/update.js", { updates: retry }) : fresh;
        });
      })
      .then(function (c) { return c && c.items ? c : getCart(); })
      .catch(function () { return getCart(); })
      .then(function (c) {
        Object.keys(batch).forEach(function (k) { if (!(k in pending)) delete pendingVid[k]; });
        inFlight = false; root.removeAttribute("data-busy");
        setCart(c);
        render();
        if (Object.keys(pending).length) { window.clearTimeout(flushT); flushT = window.setTimeout(flush, DEBOUNCE); return; }
        enforceGift();
      }, function () { inFlight = false; root.removeAttribute("data-busy"); render(); });
  }

  function addVariant(id, qty, props) {
    if (!id) return Promise.resolve();
    root.setAttribute("data-busy", "");
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return post("/cart/add.js", { items: [item] })
      .then(getCart).then(setCart)
      .catch(function (e) { showError(e.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); enforceGift(); });
  }

  /* Jeu offert : ajouté au seuil, retiré en dessous — jamais pendant une mise à jour. */
  function enforceGift() {
    if (giftBusy || inFlight || Object.keys(pending).length || !GIFT_IDS.length) return;
    var gifts = (cart.items || []).filter(function (it) { return GIFT_IDS.indexOf(it.variant_id) !== -1; });
    var n = gameBookCount();
    if (n >= GIFT_MIN && !gifts.length) {
      giftBusy = true;
      addVariant(GIFT_IDS[0], 1, { _offert: "oui" }).then(function () { giftBusy = false; });
    } else if (gifts.length && n < GIFT_MIN) {
      gifts.forEach(function (it) { setQty(it.key, 0); });
    }
  }

  function showError(msg) {
    var e = $("[data-cbcd-err]"); if (!e) return;
    e.textContent = msg || ""; e.style.display = msg ? "" : "none";
  }

  /* ---------- upsell ---------- */
  function upsellVariantId() {
    var sel = $("[data-cbcd-upvar]"); if (sel) return parseInt(sel.value, 10);
    var tog = $("[data-cbcd-uptog]"); return tog ? parseInt(tog.getAttribute("data-variant"), 10) : 0;
  }
  function upsellInCart() {
    var pid = upsellEl && upsellEl.getAttribute("data-product");
    if (!pid) return null;
    return (cart.items || []).filter(function (it) { return String(it.product_id) === pid; })[0] || null;
  }
  function syncUpsell() {
    var tog = $("[data-cbcd-uptog]"); if (!tog) return;
    var line = upsellInCart();
    if (line) tog.setAttribute("data-on", ""); else tog.removeAttribute("data-on");
    var sel = $("[data-cbcd-upvar]"); if (sel && line) sel.value = line.variant_id;
  }

  /* ---------- checkout ---------- */
  function inIframe() { try { return window.top !== window.self; } catch (e) { return true; } }
  function goToCheckout() {
    if (!(cart.items || []).length) return;
    showError("");
    /* On attend la fin des mises à jour : sinon le paiement partirait avec l'ancien panier. */
    if (inFlight || Object.keys(pending).length) {
      window.clearTimeout(flushT); flush();
      window.setTimeout(goToCheckout, 150); return;
    }
    if (inIframe()) {
      try { window.top.location.href = "/checkout"; return; }
      catch (e) { showError("L'aper\u00e7u de l'\u00e9diteur bloque le paiement. Ouvrez la boutique dans un onglet normal."); return; }
    }
    var f = document.createElement("form");
    f.method = "post"; f.action = "/cart"; f.style.display = "none";
    var i = document.createElement("input"); i.type = "hidden"; i.name = "checkout"; i.value = "1";
    f.appendChild(i); document.body.appendChild(f); f.submit();
    window.setTimeout(function () { window.location.href = "/checkout"; }, 1200);
  }
  var goBtn = $("[data-cbcd-go]");
  if (goBtn) goBtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); goToCheckout(); });

  /* ---------- events ---------- */
  itemsEl.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest("button[data-act]"); if (!b) return;
    var act = b.getAttribute("data-act");
    if (act === "more") {
      var h = b.getAttribute("data-handle");
      if (!moreOpen[h]) {
        moreOpen[h] = true; render();
        var sel0 = itemsEl.querySelector('[data-morevar="' + h + '"]'); if (sel0) sel0.focus();
        return;
      }
      var sel = itemsEl.querySelector('[data-morevar="' + h + '"]');
      if (!sel || !sel.value) { if (sel) sel.focus(); return; }
      moreOpen[h] = false; addVariant(parseInt(sel.value, 10), 1);
      return;
    }
    var keys = (b.getAttribute("data-keys") || "").split("|").filter(Boolean);
    if (!keys.length) return;
    if (act === "del") { keys.forEach(function (k) { setQty(k, 0); }); return; }
    if (act === "inc") { var first = lineByKey(keys[0]); if (first) setQty(first.key, first.quantity + 1); return; }
    for (var i = keys.length - 1; i >= 0; i--) {
      var l = lineByKey(keys[i]);
      if (l && l.quantity > 0) { setQty(l.key, l.quantity - 1); return; }
    }
  });

  root.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var tog = e.target.closest("[data-cbcd-uptog]");
    if (tog) {
      var line = upsellInCart();
      if (line) (cart.items || []).filter(function (it) { return it.variant_id === line.variant_id; }).forEach(function (it) { setQty(it.key, 0); });
      else addVariant(upsellVariantId(), 1);
      return;
    }
    if (e.target.closest("[data-cbcd-close]")) close();
  });

  root.addEventListener("change", function (e) {
    if (!e.target.matches("[data-cbcd-upvar]")) return;
    var line = upsellInCart(); if (!line) return;
    var next = parseInt(e.target.value, 10); if (next === line.variant_id) return;
    root.setAttribute("data-busy", "");
    var upd = {}; upd[line.key] = 0;
    post("/cart/update.js", { updates: upd })
      .then(function () { return post("/cart/add.js", { items: [{ id: next, quantity: line.quantity }] }); })
      .then(getCart).then(setCart)
      .catch(function (err) { showError(err.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); });
  });

  function discountSignature(c) {
    return [c.total_price, c.total_discount, (c.cart_level_discount_applications || []).length].join("|");
  }
  var promoBtn = $("[data-cbcd-promo-go]");
  if (promoBtn) {
    promoBtn.addEventListener("click", function () {
      var input = $("[data-cbcd-promo]"), code = (input.value || "").trim();
      if (!code) return;
      showError(""); root.setAttribute("data-busy", "");
      var before = discountSignature(cart);
      rawFetch("/discount/" + encodeURIComponent(code))
        .then(getCart)
        .then(function (c) {
          setCart(c); render();
          if (discountSignature(c) === before) showError("Ce code ne s'applique pas \u00e0 ce panier.");
          else input.value = "";
        })
        .catch(function () { showError("Le code n'a pas pu \u00eatre appliqu\u00e9."); })
        .then(function () { root.removeAttribute("data-busy"); });
    });
  }

  /* ---------- open / close ---------- */
  function setInert(on) {
    [".page-wrapper", "#header-group", "footer"].forEach(function (sel) {
      var el = document.querySelector(sel); if (el && "inert" in el) el.inert = on;
    });
  }
  function open() {
    if (root.hasAttribute("data-open")) return;
    lastFocus = document.activeElement;
    root.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { root.setAttribute("data-open", ""); scrim.setAttribute("data-open", ""); });
    document.documentElement.style.overflow = "hidden"; document.body.style.overflow = "hidden";
    setInert(true);
    var c = $("[data-cbcd-close]"); if (c) c.focus();
  }
  function close() {
    root.removeAttribute("data-open"); scrim.removeAttribute("data-open");
    document.documentElement.style.overflow = ""; document.body.style.overflow = "";
    setInert(false);
    window.setTimeout(function () { root.hidden = true; scrim.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  scrim.addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && root.hasAttribute("data-open")) close(); });
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cbcd-open]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    refresh().then(open);
  }, true);

  function refresh() {
    return getCart().then(function (c) { setCart(c); render(); enforceGift(); }).catch(function () {});
  }
  /* Retour arrière (bfcache) : le panier rendu dans la page peut être périmé. */
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh(); });

  ["cart-drawer-component", "#cart-drawer", ".cart-drawer"].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) { el.style.display = "none"; el.setAttribute("aria-hidden", "true"); }
  });

  /* Les ajouts faits ailleurs (buy box, apps) rafraîchissent le tiroir. */
  window.fetch = function (input, init) {
    var url = "";
    try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
    var p = rawFetch(input, init);
    if (!internalDepth && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        refresh().then(function () { if (/\/cart\/add/.test(url)) open(); });
      }).catch(function () {});
    }
    return p;
  };

  window.CBCCart = {
    open: function () { return refresh().then(open); },
    close: close, refresh: refresh, checkout: goToCheckout,
    add: function (items) { return post("/cart/add.js", { items: items }).then(refresh).then(open); },
    _state: function () { return { cart: cart, pending: pending, inFlight: inFlight }; }
  };

  if (/^\/cart\/?$/.test(window.location.pathname)) window.setTimeout(function () { refresh().then(open); }, 0);

  render();
  enforceGift();
})();
